import React, { useState, useEffect, useRef } from 'react'
import { PlusOutlined } from '@ant-design/icons'
import { Button, Drawer, Input, Form } from 'antd'
import notification from 'mrx-notification'
import styles from './CreatePayPalSetting.module.scss'
import { PropsFromRedux, connector } from './container'

const CreatePayPalSetting = (props: PropsFromRedux) => {
  const [isVisible, setVisible] = useState(false)
  const refEl = useRef<Input>(null)

  const { isLoading, createPayPalSetting } = props

  useEffect(() => {
    if (isVisible) {
      refEl.current && refEl.current.focus()
    }
  }, [isVisible])

  const showDrawer = () => {
    setVisible(!isVisible)
  }

  const [form] = Form.useForm()

  const handleClose = () => {
    setVisible(false)
    form.resetFields()
  }

  const onFinishHandler = async (values: any) => {
    const isSaved = await createPayPalSetting({
      name: values.name,
      accountEmail: values.accountEmail,
      clientId: values.clientId,
      secretKey: values.secretKey,
      accessToken: values.accessToken
    })
    if (isSaved) {
      notification.success({
        message: 'Successfully',
        description: 'PayPal Setting was created successfully!'
      })
      handleClose()
    }
  }

  return (
    <>
      <Button type='primary' onClick={showDrawer}>
        <PlusOutlined />
        CREATE
      </Button>
      <Drawer title='Create PayPal Setting' width='400' onClose={handleClose} visible={isVisible} forceRender>
        <Form layout='vertical' hideRequiredMark onFinish={onFinishHandler} form={form}>
          <Form.Item name='name' label='Name' rules={[{ required: true, message: 'Please input PayPal setting name!' }]}>
            <Input ref={refEl} />
          </Form.Item>
          <Form.Item name='accountEmail' label='Account Email' rules={[{ required: true, message: 'Please input Account Email!' }]}>
            <Input />
          </Form.Item>
          <Form.Item name='clientId' label='Client ID' rules={[{ required: true, message: 'Please input Client ID!' }]}>
            <Input />
          </Form.Item>
          <Form.Item name='secretKey' label='Secret Key' rules={[{ required: true, message: 'Please input Secret Key!' }]}>
            <Input />
          </Form.Item>
          <Form.Item name='accessToken' label='Access Token' rules={[{ required: true, message: 'Please input Access Token!' }]}>
            <Input />
          </Form.Item>
          <div className={styles.buttonsContainer}>
            <Button onClick={handleClose} className={styles.createButton}>
              Close
            </Button>
            <Button type='primary' htmlType='submit' loading={isLoading}>
              Create
            </Button>
          </div>
        </Form>
      </Drawer>
    </>
  )
}

export default connector(CreatePayPalSetting)
